<template>
  <div v-if="loading" class="h-32 bg-white p-4 shadow">
    <div class="loadingEl my-2 block h-8 w-32 rounded-md bg-gray-50" />
    <div class="loadingEl my-1 h-1/2 rounded-md bg-gray-50" />
  </div>
  <div v-show="!loading" class="overflow-hidden rounded-md bg-white px-4 py-3 shadow">
    <div class="pb-3 flex justify-between item-center">
      <h3 class="dashboard-card-title">
        {{ $t("dashboard.project.planner_card.current_procedures") }}
      </h3>
      <router-link
        :to="{
          name: 'PlannerV2',
          params: {
            customer_name: this.currentCustomerName,
            site_id: this.currentSiteId,
          },
        }"
      >
        <div
          class="px-2 py-1 font-bold text-yellow-700 hover:bg-yellow-300 hover:text-yellow-900 rounded-md"
        >
          <ArrowRightIcon class="h-4 w-4" aria-hidden="true" />
        </div>
      </router-link>
    </div>
    <div v-if="this.openLeafNodes.length > 0">
      <div class="flow-root px-4 py-2">
        <div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div class="lg:px-s8 inline-block min-w-full pt-2 align-middle sm:px-6">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
                <tr
                  class="sm:py-3.5 py-2 font-semibold text-gray-900 text-xs sm:text-sm whitespace-nowrap"
                >
                  <th scope="col" class="pr-3 sm:pl-0 w-75 sm:w-auto text-left">
                    {{ $t("dashboard.project.planner_card.procedure") }}
                  </th>
                  <th scope="col" class="pr-2 w-25 sm:w-auto">
                    {{ $t("dashboard.project.planner_card.start_date") }}
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="(node, index) in this.openLeafNodes" :key="index">
                  <td
                    class="py-2 pr-2 text-xs sm:text-sm text-gray-600 w-75 sm:w-auto break-words whitespace-normal"
                  >
                    {{ joinParents(node.parent_names, 2) + " / " }}
                    <span class="font-medium">{{ node.name }}</span>
                  </td>
                  <td
                    class="whitespace-nowrap py-2 pr-2 text-xs sm:text-sm text-gray-500 sm:pl-0 w-25 sm:w-auto text-center"
                  >
                    {{ formatDate(node.actual_start) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="py-2 text-sm">
      {{ $t("dashboard.project.planner_card.no_current_procedures") }}
    </div>
  </div>
</template>

<script>
import { ArrowRightIcon } from "@heroicons/vue/24/solid";
import { format } from "date-fns";
import PlannerRepository from "@/repositories/PlannerRepository";
import logger from "@/services/logger";

export default {
  name: "PlannerCard",
  data() {
    return {
      openLeafNodes: [],
      loading: false,
    };
  },
  mounted() {
    this.getOpenLeafNodesData();
  },
  components: {
    ArrowRightIcon,
  },
  methods: {
    getOpenLeafNodesData() {
      this.loading = true;

      return PlannerRepository.loadActiveLeafNodes(this.currentCustomerName, this.currentSiteId)
        .then((data) => {
          this.openLeafNodes = data["data"];
        })
        .catch((error) => {
          if (error?.response?.status !== 404) {
            logger.error(error);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(dateString) {
      return format(new Date(dateString), "dd.MM.yyyy");
    },
    joinParents(parentList, n) {
      const lastNParents = parentList.slice(-n); // Get the last N elements

      return lastNParents.join(" > ");
    },
  },
};
</script>
